import {useCallback, useEffect, useRef} from "react";
import {debounce} from "../utils/CleversiteUtilities";

export function useTrackVisibility(handleVisibility: () => void, options: {
    threshold?: number,
    throttleInterval?: number,
    root?: HTMLElement,
    dependencies?: any[],
}) {
    const {threshold = 0, throttleInterval = 2000, dependencies = []} = options;

    const ref = useRef(null);

    // since debounce returns a new function, handleVisibility must be pure!
    const debouncedHandler = useCallback(debounce(handleVisibility, throttleInterval, true), []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    debouncedHandler();
                }
            },
            {
                threshold: threshold,
                root: options.root,
            }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, [ref, ...dependencies]);

    return ref;
}